export const initialState = {
    registrarID: '',
    extension: '',
    overrideCredentials: false, // by default, use registrar credentials, IF use username/password, set this to True
    username: '',
    password: '',
    useAdvancedTransfer: false, // Microsoft Teams Only - enables correct free/busy status following call transfer
};

export const initValidationError = {
    ...initialState,
    overrideCredentials: '',
};

export const aorsPath = '/aors';

/**@example '/aors/{registrationId}?registrar={registrarId}' */
export const aorsPathWithRegistrar = `${aorsPath}${location.search}`;

export const breadCrumbTrail = [
    { label: 'Resources', path: '' },
    { label: 'TRS Registration Management', path: aorsPathWithRegistrar },
    { label: 'Add Registration', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Resources', path: '' },
    { label: 'TRS Registration Management', path: aorsPath },
    { label: 'Edit Registration', path: '' },
];

export const breadCrumbTrailCsv = [
    { label: 'Resources', path: '' },
    { label: 'TRS Registration Management', path: aorsPath },
    { label: 'CSV Upload', path: '' },
];

export const addHeader = 'TRS Registration Details';
export const editHeader = 'Edit TRS Registration Details';
export const csvHeader = 'CSV Upload: TRS Registrations';

export const ERROR_MESSAGES = {
    REGISTRAR_REQUIRED: 'Registrar is required',
    EXTENSION_REQUIRED:
        'Extension is required and must be at least 3 characters',
    EXTENSION_DUPLICATE:
        'This extension already exists for the selected registrar',
};

// Mock Registrar Data
export const registrarSystems = [
    { id: '1', name: 'London Main Registrar', uri: 'london.registrar.com' },
    { id: '2', name: 'Frankfurt Registrar', uri: 'frankfurt.registrar.com' },
    { id: '3', name: 'Singapore Registrar', uri: 'singapore.registrar.com' },
    { id: '4', name: 'New York Registrar', uri: 'newyork.registrar.com' },
    { id: '5', name: 'Sydney Registrar', uri: 'sydney.registrar.com' },
];

// Mock AORs Data
export const initialAORs = [
    {
        id: '1',
        extension: '1001',
        pbxId: '1',
        pbxName: 'London Main PBX',
        registrarId: '1',
        registrarName: 'London Main Registrar',
        status: 'registered',
        assignedNumber: '+44203456789',
        platform: 'Microsoft Teams',
        username: 'user1001@contoso.com',
        cluster: 'UK Cluster',
        region: 'UK',
        enabled: true,
        lastRegistered: '2024-01-20T10:30:00Z',
        createdAt: '2024-01-15',
        authentication: true,
    },
    {
        id: '2',
        extension: '1002',
        pbxId: '1',
        pbxName: 'London Main PBX',
        registrarId: '1',
        registrarName: 'London Main Registrar',
        status: 'unregistered',
        assignedNumber: '+44203456790',
        platform: 'Zoom Phone',
        username: 'user1002@contoso.com',
        cluster: 'UK Cluster',
        region: 'UK',
        enabled: false,
        lastRegistered: '2024-01-19T14:45:00Z',
        createdAt: '2024-01-15',
        authentication: false,
    },
    {
        id: '3',
        extension: '2001',
        pbxId: '2',
        pbxName: 'Frankfurt PBX',
        registrarId: '2',
        registrarName: 'Frankfurt Registrar',
        status: 'registered',
        assignedNumber: '+4969123456789',
        platform: 'Microsoft Teams',
        username: 'user2001@contoso.de',
        cluster: 'EU West Cluster',
        region: 'EU',
        enabled: true,
        lastRegistered: '2024-01-20T08:15:00Z',
        createdAt: '2024-01-14',
        authentication: true,
    },
    {
        id: '4',
        extension: '2002',
        pbxId: '2',
        pbxName: 'Frankfurt PBX',
        registrarId: '2',
        registrarName: 'Frankfurt Registrar',
        status: 'failed',
        assignedNumber: '+4969123456790',
        platform: 'RingCentral',
        username: 'user2002@contoso.de',
        cluster: 'EU West Cluster',
        region: 'EU',
        enabled: true,
        lastRegistered: '2024-01-18T16:30:00Z',
        createdAt: '2024-01-14',
        authentication: true,
    },
    {
        id: '5',
        extension: '3001',
        pbxId: '3',
        pbxName: 'Singapore PBX',
        registrarId: '3',
        registrarName: 'Singapore Registrar',
        status: 'registered',
        assignedNumber: '+6567891234',
        platform: 'Microsoft Teams',
        username: 'user3001@contoso.sg',
        cluster: 'APAC Cluster',
        region: 'APAC',
        enabled: true,
        lastRegistered: '2024-01-20T02:20:00Z',
        createdAt: '2024-01-12',
        authentication: true,
    },
    {
        id: '6',
        extension: '3002',
        pbxId: '3',
        pbxName: 'Singapore PBX',
        registrarId: '3',
        registrarName: 'Singapore Registrar',
        status: 'unregistered',
        assignedNumber: '+6567891235',
        platform: 'Cisco Webex',
        username: 'user3002@contoso.sg',
        cluster: 'APAC Cluster',
        region: 'APAC',
        enabled: false,
        lastRegistered: '2024-01-17T11:10:00Z',
        createdAt: '2024-01-12',
        authentication: false,
    },
    {
        id: '7',
        extension: '4001',
        pbxId: '4',
        pbxName: 'New York PBX',
        registrarId: '4',
        registrarName: 'New York Registrar',
        status: 'registered',
        assignedNumber: '+12125551234',
        platform: 'Microsoft Teams',
        username: 'user4001@contoso.us',
        cluster: 'US East Cluster',
        region: 'US',
        enabled: true,
        lastRegistered: '2024-01-20T13:45:00Z',
        createdAt: '2024-01-10',
        authentication: true,
    },
    {
        id: '8',
        extension: '4002',
        pbxId: '4',
        pbxName: 'New York PBX',
        registrarId: '4',
        registrarName: 'New York Registrar',
        status: 'registered',
        assignedNumber: '+12125551235',
        platform: 'Zoom Phone',
        username: 'user4002@contoso.us',
        cluster: 'US East Cluster',
        region: 'US',
        enabled: true,
        lastRegistered: '2024-01-20T09:30:00Z',
        createdAt: '2024-01-10',
        authentication: true,
    },
    {
        id: '9',
        extension: '5001',
        pbxId: '5',
        pbxName: 'Sydney PBX',
        registrarId: '5',
        registrarName: 'Sydney Registrar',
        status: 'failed',
        assignedNumber: '+61298765432',
        platform: 'RingCentral',
        username: 'user5001@contoso.au',
        cluster: 'APAC South Cluster',
        region: 'APAC',
        enabled: true,
        lastRegistered: '2024-01-19T06:15:00Z',
        createdAt: '2024-01-08',
        authentication: false,
    },
    {
        id: '10',
        extension: '5002',
        pbxId: '5',
        pbxName: 'Sydney PBX',
        registrarId: '5',
        registrarName: 'Sydney Registrar',
        status: 'unregistered',
        assignedNumber: '+61298765433',
        platform: 'Microsoft Teams',
        username: 'user5002@contoso.au',
        cluster: 'APAC South Cluster',
        region: 'APAC',
        enabled: false,
        lastRegistered: '2024-01-16T22:40:00Z',
        createdAt: '2024-01-08',
        authentication: true,
    },
];

// Status configurations for rendering
export const STATUS_CONFIG = {
    registered: {
        color: 'green',
        bgColor: 'green.50',
        textColor: 'green.600',
        label: 'Registered',
    },
    unregistered: {
        color: 'gray',
        bgColor: 'gray.50',
        textColor: 'gray.600',
        label: 'Unregistered',
    },
    failed: {
        color: 'red',
        bgColor: 'red.50',
        textColor: 'red.600',
        label: 'Failed',
    },
};

// Platform configurations for icons and tooltips
export const PLATFORM_CONFIG = {
    'Microsoft Teams': {
        icon: 'teams',
        color: '#5C2D91',
        tooltip: 'Microsoft Teams',
    },
    'Zoom Phone': {
        icon: 'zoom',
        color: '#2D8CFF',
        tooltip: 'Zoom Phone',
    },
    RingCentral: {
        icon: 'ringcentral',
        color: '#FF6900',
        tooltip: 'RingCentral',
    },
    'Cisco Webex': {
        icon: 'webex',
        color: '#00BCEB',
        tooltip: 'Cisco Webex',
    },
};

// Company filter options (mock data)
export const COMPANY_OPTIONS = [
    { id: 'all', name: 'All Companies' },
    { id: 'contoso', name: 'Contoso Ltd' },
    { id: 'fabrikam', name: 'Fabrikam Inc' },
    { id: 'adventure', name: 'Adventure Works' },
];

// Partner filter options (mock data)
export const PARTNER_OPTIONS = [
    { id: 'all', name: 'All Partners' },
    { id: 'partner1', name: 'Partner One' },
    { id: 'partner2', name: 'Partner Two' },
    { id: 'partner3', name: 'Partner Three' },
];

export const tooltipChildrenStyles = {
    '& span': {
        w: 'full',
    },
};
